export const getters = {
  couponUsableList (state) {
    return state.couponUsableList
  },
  currCouponBy: (state) => ({ guardMissingForm = true } = {}) => {
    const crid = guardMissingForm
      ? state.createForm?.crid
      : state.createForm.crid
    return state.couponUsableList.find(item => item.crid === crid)
  },
  currCoupon (state, getters) {
    return getters.currCouponBy()
  },
}
